import { ScanQrCode, ScanSearch, UsersRound } from "lucide-react";

import { MainNavigationLinkProps } from "./MainNavigationLink";

export type NavigationGroup = { title?: string; children: NavigationRoute[] };
export type NavigationRoute = MainNavigationLinkProps;

export const mainNavigationStart: NavigationGroup = {
  children: [
    // {
    //   label: "dashboard",
    //   to: "/",
    //   icon: LayoutDashboard,
    // },
    {
      label: "clients",
      to: "/",
      icon: UsersRound,
    },
    {
      label: "oneClick",
      to: "/add-post",
      icon: ScanQrCode,
    },
    {
      label: "quickModuleAccess",
      to: "/read-post",
      icon: ScanSearch,
    },
    //todo add other routes
  ],
};
